<template>
  <router-view />
</template>

<script>
export default {
  name: 'ServicesLayout',
};
</script>
